import {Modal, Spin, Tag} from "antd";
import {FontAwesomeIcon} from "~/components";
import {useGetTrendsKeywordHistoryQuery} from "~/reduxs/api/trendsApiSlice";

const COLOR = '#fa541c';

/**
 * Biểu đồ tần suất trend: các ngày 1 từ khoá xuất hiện trong bảng trending (30 ngày,
 * từ trend_snapshots), trục Y = mức lượt tìm kiếm đã parse (traffic_min). SVG tự vẽ
 * theo pattern chart của dự án (PsiTrendChart/RankChart — không dùng lib chart).
 */
function TrendChart({points = []}) {

	if (points.length < 2) {
		return (
			<p style={{color: '#6b7280', fontSize: 13}}>
				Mới ghi nhận {points.length} ngày — cần ít nhất 2 ngày để vẽ biểu đồ.
				Hệ thống lưu snapshot mỗi ngày, quay lại sau nhé.
			</p>
		);
	}

	const W = 640, H = 220, P = 30;
	const innerW = W - P * 2, innerH = H - P * 2;
	const n = points.length;
	const max = Math.max(1, ...points.map((d) => d.traffic_min || 0));
	const x = (i) => P + (innerW * i) / (n - 1);
	const y = (v) => P + innerH - (innerH * (v || 0)) / max;
	const line = 'M ' + points.map((p, i) => `${x(i)},${y(p.traffic_min)}`).join(' L ');
	const ticks = [0, Math.floor((n - 1) / 2), n - 1];

	return (
		<svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" style={{width: '100%', height: 220}}>
			{[0, 0.5, 1].map((g) => (
				<line key={g} x1={P} y1={P + innerH * g} x2={W - P} y2={P + innerH * g}
					stroke="#eef0f4" strokeWidth="1" vectorEffect="non-scaling-stroke" />
			))}
			<path d={line} fill="none" stroke={COLOR} strokeWidth="2.5"
				strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
			{points.map((p, i) => (
				<circle key={i} cx={x(i)} cy={y(p.traffic_min)} r="3" fill="#fff"
					stroke={COLOR} strokeWidth="2" vectorEffect="non-scaling-stroke" />
			))}
			{ticks.map((i) => (
				<text key={i} x={x(i)} y={H - 6} fontSize="10" fill="#9ca3af"
					textAnchor={i === 0 ? 'start' : i === n - 1 ? 'end' : 'middle'}>
					{String(points[i].date).slice(5)}
				</text>
			))}
		</svg>
	);
}

/**
 * Modal "lịch sử trend của 1 từ khoá" — mở khi bấm badge "X ngày" trên bảng trending.
 */
function TrendsKeywordModal({open, keyword, hash, geo, onCancel}) {

	const {data, isFetching} = useGetTrendsKeywordHistoryQuery(
		{geo, hash},
		{skip: !open || !hash}
	);

	const points = data?.points || [];

	return (
		<Modal
			open={open}
			onCancel={onCancel}
			footer={null}
			width={720}
			title={
				<span>
					<FontAwesomeIcon icon="fa-light fa-fire" style={{color: COLOR, marginRight: 8}} />
					Lịch sử trend: {keyword}
				</span>
			}
		>
			{isFetching ? (
				<div style={{textAlign: 'center', padding: 32}}><Spin /></div>
			) : (
				<div>
					<p style={{color: '#6b7280', fontSize: 13, marginBottom: 12}}>
						Xuất hiện trong bảng trending <strong>{points.length} ngày</strong> (30 ngày gần nhất).
					</p>
					<TrendChart points={points} />
					<div style={{display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 12}}>
						{points.map((p) => (
							<Tag key={p.date}>{p.date}{p.approx_traffic ? ` · ${p.approx_traffic}` : ''}</Tag>
						))}
					</div>
				</div>
			)}
		</Modal>
	);
}

export default TrendsKeywordModal;
